import { Column, Row, Text } from '@smuchile/pkg-unimarc-components'
import { eventClick } from '@smuchile/pkg-unimarc-hooks'
import { IOptionSelect, SelectFilter } from 'components/SelectFilter'

interface OrderByOptions {
  label: string
  placeholder: string
  value: number
}
interface FiltersProps {
  orderBy: IOptionSelect
  orderByOptions: OrderByOptions[]
  onChangeOrder?: (order: 0 | 1) => void
  setOrderBy: (value: IOptionSelect) => void
}

export const Filters = ({
  orderBy,
  orderByOptions,
  onChangeOrder,
  setOrderBy
}: FiltersProps) => {
  const changeOrder = (value: IOptionSelect) => {
    onChangeOrder(value.value as 0 | 1)
    setOrderBy(value)
  }

  return (
    <Row alignItems='end'>
      <Column maxWidth='221px'>
        <Row maxWidth='221px'>
          <Column
            alignItems='center'
            borderEdge='right'
            padding='0 5px 0 0'
          >
            <Text
              color='gray'
              fontSize='md'
            >
              Ordenar por
            </Text>
          </Column>
          <Column
            maxWidth='140px'
            padding='0 5px'
          >
            <SelectFilter
              onChange={(option) => {
                eventClick({
                  event: 'interacciones-mis-compras',
                  eventCategory: 'ordenar-por',
                  event_label: option.value ? 'mas-antiguas' : 'mas-recientes'
                })
                return changeOrder(option)
              }}
              options={orderByOptions}
              value={orderBy}
            />
          </Column>
        </Row>
      </Column>
    </Row>
  )
}
